<template>
  <div class="actions-row">
    <template v-if="isReady">
      <!-- Preview button -->
      <el-button
        type="primary"
        title="Listen Audio"
        plain
        size="mini"
        class="actions-row__action audio-item-button"
        @click="$emit('preview')"
      >
        <volume-high title="Listen Audio" />
      </el-button>

      <el-button
        type="warning"
        :title="title"
        plain
        size="mini"
        class="audio-item-button"
        @click="$emit('edit')"
      >
        <movie-edit title="Edit Video" class="videoItemIcon" />
      </el-button>

      <!-- Download button -->
      <el-button
        type="success"
        title="Download Audio"
        size="mini"
        class="actions-row__action audio-item-button"
        @click="$emit('download')"
      >
        <download title="Download Audio" />
      </el-button>

      <!-- Delete audio button -->
      <el-button
        type="primary"
        title="Copy Link"
        size="mini"
        class="actions-row__action audio-item-button"
        @click="$emit('copy')"
      >
        <content-copy title="Copy Link" />
      </el-button>
    </template>

    <el-button
      v-if="isRemovable"
      type="danger"
      title="Delete Audio"
      size="mini"
      class="actions-row__action audio-item-button"
      @click="$emit('delete')"
    >
      <close-thick title="Delete Audio" />
    </el-button>
  </div>
</template>

<script>
/** icons */
import Download from "vue-material-design-icons/Download.vue";
import ContentCopy from "vue-material-design-icons/ContentCopy.vue";
import VolumeHigh from "vue-material-design-icons/VolumeHigh.vue";
import CloseThick from "vue-material-design-icons/CloseThick.vue";
import MovieEdit from "vue-material-design-icons/MovieEdit.vue";
import { mapGetters } from "vuex";

// @group Media/Audio
// Audio actions panel
export default {
  name: "AudioHeaderActions",
  components: {
    /** icons */
    Download,
    ContentCopy,
    VolumeHigh,
    CloseThick,
    MovieEdit
  },
  computed: {
    ...mapGetters(["channelType"]),
    title(){
      return this.channelType === 'audio' ? 'Edit audio' : 'Edit video'
    }
  },
  props: {
    /** Is covertion finished */
    isReady: {
      type: Boolean,
      default: true
    },
    /** Is it possible to delete audio */
    isRemovable: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.actions-row {
  display: flex;

  &__action {
    margin-left: 1em;
  }
}

/** buttons */
.audio-item-button {
  height: 2rem;
  width: 2rem;
  margin: 0 5px;
}

.material-design-icon__svg {
  padding-left: 2px;
  height: 1rem !important;
  width: 1rem !important;
  margin-top: 1px !important;
}

@media only screen and (max-width: 400px) {
  /** buttons */
  .actions-row {
    display: flex;

    &__action {
      width: 1.8rem;
      height: 1.8rem;
      margin-left: 0.5em;
    }
  }
  .material-design-icon__svg {
    padding-left: 2px;
    height: 0.9rem !important;
    width: 0.9rem !important;
    margin-top: 1px !important;
  }
}
@media only screen and (min-width: 1200px) {
}
@media only screen and (min-width: 1920px) {
  /** buttons */
  .actions-row {
    display: flex;

    &__action {
      margin-left: 1em;
    }
  }
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    margin-top: 2px !important;
  }
}
</style>
